import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Placeholder slot for the future Google OAuth provider. Disabled on purpose: no integration is simulated.
 * Wiring it later only requires a redirect to the backend OAuth route and `applySession` with the returned tokens.
 */
export const GoogleSoonButton = () => {
  const { t } = useTranslation();
  return (
    <div className="pt-1">
      <div className="relative my-3 flex items-center">
        <div className="h-px flex-1 bg-border" />
        <span className="px-3 text-xs uppercase tracking-wide text-muted-foreground">{t("auth.or")}</span>
        <div className="h-px flex-1 bg-border" />
      </div>
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
          <span className="block">
            <Button type="button" variant="outline" className="h-10 w-full gap-2 bg-card" disabled data-testid="auth-google-soon-button" aria-describedby="google-soon-hint">
              <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true"><path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.5 3.8-5.5 3.8-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.9 1.5l2.6-2.6C16.8 3 14.6 2 12 2 6.5 2 2 6.5 2 12s4.5 10 10 10c5.8 0 9.6-4.1 9.6-9.8 0-.7-.1-1.2-.2-1.7H12z" /></svg>
              {t("auth.google")}
              <span className="rounded-md border border-border bg-muted px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground">{t("common.comingSoon")}</span>
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent className="bg-card text-foreground" id="google-soon-hint">{t("auth.googleSoon")}</TooltipContent>
      </Tooltip>
    </div>
  );
};
